// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("wwwroot/assets/bg/map-pin.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("wwwroot/assets/bg/map-bg.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.jrC9DTHLSmxu3sqWspgZ {
  position: relative;
  block-size: 100svb;
}
.jrC9DTHLSmxu3sqWspgZ .mT6FBNZf4LI7l4bOVFsA {
  position: relative;
  min-block-size: 100svb;
  min-inline-size: 320px;
  display: grid;
  grid-template-columns: 4fr 5fr;
  grid-template-rows: 100%;
  grid-template-areas: "header main";
}
@media (max-width: 768px) {
  .jrC9DTHLSmxu3sqWspgZ .mT6FBNZf4LI7l4bOVFsA {
    grid-template-columns: 100%;
    grid-template-rows: 110px 1fr auto;
    grid-template-areas: "header" "main" "footer";
  }
  .jrC9DTHLSmxu3sqWspgZ .mT6FBNZf4LI7l4bOVFsA .USz6zw9C_h18iSTWqDgf {
    display: none;
  }
}
.jrC9DTHLSmxu3sqWspgZ .mT6FBNZf4LI7l4bOVFsA ._YNMBhEJE9HJpohZKCUq {
  grid-area: header;
  background: var(--cw-color-back-blue);
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: center;
  padding: 24px;
}
.jrC9DTHLSmxu3sqWspgZ .mT6FBNZf4LI7l4bOVFsA ._YNMBhEJE9HJpohZKCUq .e0SRisDMZEfJt3JYfgNW {
  align-self: center;
  inline-size: 100%;
  padding: 16px;
  max-inline-size: fit-content;
}
.jrC9DTHLSmxu3sqWspgZ .mT6FBNZf4LI7l4bOVFsA ._YNMBhEJE9HJpohZKCUq .USz6zw9C_h18iSTWqDgf {
  background-color: var(--cw-color-back-primary);
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center;
  background-size: contain;
  block-size: 75%;
}
.jrC9DTHLSmxu3sqWspgZ .mT6FBNZf4LI7l4bOVFsA .ZwQRJxgABbigck5WCtX9 {
  grid-area: main;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-size: cover;
  background-position: center;
  padding-block: 32px;
}
.jrC9DTHLSmxu3sqWspgZ .mT6FBNZf4LI7l4bOVFsA .ZwQRJxgABbigck5WCtX9 .ORd3tC6WB9o99Sfm_Isv {
  display: flex;
  block-size: 100%;
  position: relative;
  flex-direction: row;
  align-content: center;
  align-items: center;
  justify-content: center;
}
`, "",{"version":3,"sources":["webpack://./projects/core-app/src/anonymous-shell/anonymous-shell.component.less"],"names":[],"mappings":"AAAA;EAGQ,kBAAA;EACA,kBAAA;AADR;AAHA;EAOY,kBAAA;EACA,sBAAA;EACA,sBAAA;EACA,aAAA;EACA,8BAAA;EACA,wBAAA;EACA,kCAAA;AADZ;AAGY;EAAA;IACI,2BAAA;IACA,kCAAA;IACA,6CAAA;EAAd;EAHU;IASQ,aAAA;EAHlB;AACF;AAtBA;EA6BgB,iBAAA;EACA,qCAAA;EACA,aAAA;EACA,sBAAA;EACA,oBAAA;EACA,uBAAA;EACA,aAAA;AAJhB;AA/BA;EAsCoB,kBAAA;EACA,iBAAA;EACA,aAAA;EACA,4BAAA;AAJpB;AArCA;EA6CoB,8CAAA;EACA,oEAAA;EACA,wBAAA;EACA,eAAA;AALpB;AA3CA;EAqDgB,eAAA;EACA,mDAAA;EACA,sBAAA;EACA,2BAAA;EACA,mBAAA;AAPhB;AAlDA;EA4DoB,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;EACA,uBAAA;AAPpB","sourcesContent":[":local {\n\n    .AnonymousShell {\n        position: relative;\n        block-size: 100svb;\n\n        .gridContainer {\n            position: relative;\n            min-block-size: 100svb;\n            min-inline-size: 320px;\n            display: grid;\n            grid-template-columns: 4fr 5fr;\n            grid-template-rows: 100%;\n            grid-template-areas: \"header main\";\n\n            @media(max-width: 768px) {\n                grid-template-columns: 100%;\n                grid-template-rows: 110px 1fr auto;\n                grid-template-areas:\n                    \"header\"\n                    \"main\"\n                    \"footer\";\n\n                .mapPin {\n                    display: none;\n                }\n            }\n\n            .gridHeaderRow {\n                grid-area: header;\n                background: var(--cw-color-back-blue);\n                display: flex;\n                flex-direction: column;\n                align-items: stretch;\n                justify-content: center;\n                padding: 24px;\n\n                .logoImage {\n                    align-self: center;\n                    inline-size: 100%;\n                    padding: 16px;\n                    max-inline-size: fit-content;\n                }\n\n                .mapPin {\n                    background-color: var(--cw-color-back-primary);\n                    background: url('wwwroot/assets/bg/map-pin.png') no-repeat center;\n                    background-size: contain;\n                    block-size: 75%;\n                }\n            }\n\n            .gridContentRow {\n                grid-area: main;\n                background: url('wwwroot/assets/bg/map-bg.jpg');\n                background-size: cover;\n                background-position: center;\n                padding-block: 32px;\n\n                .centerWrapper {\n                    display: flex;\n                    block-size: 100%;\n                    position: relative;\n                    flex-direction: row;\n                    align-content: center;\n                    align-items: center;\n                    justify-content: center;\n                }\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"AnonymousShell": `jrC9DTHLSmxu3sqWspgZ`,
	"gridContainer": `mT6FBNZf4LI7l4bOVFsA`,
	"mapPin": `USz6zw9C_h18iSTWqDgf`,
	"gridHeaderRow": `_YNMBhEJE9HJpohZKCUq`,
	"logoImage": `e0SRisDMZEfJt3JYfgNW`,
	"gridContentRow": `ZwQRJxgABbigck5WCtX9`,
	"centerWrapper": `ORd3tC6WB9o99Sfm_Isv`
};
export default ___CSS_LOADER_EXPORT___;
